<template>
  <header class="mx-auto px-4 sm:px-6 md:px-8">
    <h1 class="text-3xl leading-9 font-semibold font-headline antialiased  text-bhav-blue-500">
      Enhanced Data Feed Manager
    </h1>
    <Version v-if="user?.id ?? false" />
  </header>
  <section class="grid grid-cols-1 lg:grid-cols-6 gap-5 mt-12 px-5">
    <h2 class="sr-only">Available Sections</h2>

    <router-link :to="{name: route.name}" v-for="route,i in routes" :key="`menu-${i}`" >
      <article class="flex flex-col items-center justify-center gap-4 aspect-square bg-white rounded hover:bg-bhav-blue-50 transition-colors delay-50 ease-in">
        <div class="text-4xl text-white bg-bhav-blue-500 py-5 rounded-full w-20 h-20 text-center">
          <span class="fak" :class="route.meta.icon"></span>
        </div>
        <h3 class="text-bhav-blue-700 font-bold text-lg">{{ route.meta.title }}</h3>
      </article>
    </router-link>
  </section>
</template>
  
<script>
import Version from '@/components/Version.vue';
import { useAuthStore } from '@/stores/auth';
import { mapState } from 'pinia';

export default {
  components: { Version },
  computed: {
    ...mapState(useAuthStore, ['user']),
    routes() {
      return this.$router.getRoutes()
        .filter(route => {
          return route?.meta?.menu === true && route.name != 'dashboard' && this.user.level >= route.meta.acl
        })
        .sort((a,b) => a.meta?.order > b.meta?.order ? 1 : -1);
    }
  }
}
</script>
  